//


import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Scrollspy from "react-scrollspy";
import { Collapse, Container, NavLink, NavbarToggler, Nav, NavItem } from "reactstrap";
import "./scss/navbar.scss";
import ButtonAesthetic from '../../../assets/scss/components/buttonaesthetic';

// Import Images
import logoinit from "../../../assets/images/landing/backapp-icon.png";

const Navbar = () => {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [activeLink, setActiveLink] = useState();
  const [scrolled, setScrolled] = useState(false);

  const toggle = () => setIsOpenMenu(!isOpenMenu);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const activation = (event) => {
      const target = event.target;
      if (target && target.tagName === "A") {
        target.classList.add("active");

        // Desactiva después de 5 segundos
        setTimeout(() => {
          target.classList.remove("active");
        }, 1000);
      }
    };

    const links = document.querySelectorAll(".navbar a");

    links.forEach((link) => {
      link.addEventListener("click", activation);
    });

    return () => {
      links.forEach((link) => {
        link.removeEventListener("click", activation);
      });
    };
  }, []);

  return (
    <React.Fragment>
      <nav
        className={`navbar navbar-expand-lg fixed-top ${scrolled ? "navbar-blur scrolled" : ""}`}
        id="navbar"
      >
        <Container>
          <Link className="navbar-brand" to="#">
            <img
              src={logoinit}
              className="card-logo"
              alt="logo"
              height="37"
            />
          </Link>

          <NavbarToggler
            className="navbar-toggler py-0 fs-20 text-body"
            onClick={toggle}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="mdi mdi-menu"></i>
          </NavbarToggler>

          <Collapse
            isOpen={isOpenMenu}
            className="navbar-collapse"
            id="navbarSupportedContent"
          >
            <Scrollspy
              offset={-18}
              items={[
                "hero",
                "aboutbackapp",
                "services",
                "benefits",
                "areateam",
                "contact",
              ]}
              currentClassName="active"
              className="navbar-nav mx-auto mt-2 mt-lg-0"
              id="navbar-example"
            >
              <li className="nav-item">
                <NavLink className="fs-15 fw-semibold nav-glow" href="#home">
                  Inicio
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="fs-15 fw-semibold nav-glow" href="#aboutbackapp">
                  Nosotros
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="fs-15 fw-semibold nav-glow" href="#services">
                  Servicios
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="fs-15 fw-semibold nav-glow" href="#benefits">
                  Beneficios
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="fs-15 fw-semibold nav-glow" href="#areateam">
                  Team
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="fs-15 fw-semibold nav-glow" href="#contact">
                  Contacto
                </NavLink>
              </li>
            </Scrollspy>
            <div className="nav-item animate-button">
              <ButtonAesthetic
                text="Ingresar"
                href="https://iassistant.backappchile.com"
              />
            </div>
          </Collapse>
        </Container>
      </nav>
    </React.Fragment>
  );
};

export default Navbar;
